import React from "react";
import { Router, Route, Switch, RouteComponentProps } from "react-router-dom";
import { history } from "./history";
const LoginWrapper = React.lazy(
  () => import("./containers/Login/LoginWrapper")
);
const UpdatePasswordWrapper = React.lazy(
  () => import("./containers/UpdatePassword/UpdatePasswordWrapper")
);
const ForgotPasswordWrapper = React.lazy(
  () => import("./containers/ForgotPassword/ForgotPasswordWrapper")
);
const AccessDeniedWrapper = React.lazy(
  () => import("./containers/AccessDenied/AccessDeniedWrapper")
);

const RequestMembership = React.lazy(
  () => import("./containers/RequestMembership/RequestMembership")
);

const App: React.FC<any> = () => {
  return (
    <Router history={history}>
      <React.Suspense fallback={<div></div>}>
        <Switch>
          <Route
            exact
            path="/login"
            render={(props: RouteComponentProps) => <LoginWrapper {...props} />}
          />
          <Route
            exact
            path="/forgot-password"
            render={(props: RouteComponentProps) => (
              <ForgotPasswordWrapper {...props} />
            )}
          />
          <Route
            exact
            path="/update-password/:otp"
            render={(props: RouteComponentProps) => (
              <UpdatePasswordWrapper {...props} />
            )}
          />
          <Route
            exact
            path="/error/access-denied"
            render={(props: any) => <AccessDeniedWrapper {...props} />}
          />
          <Route
            exact
            path="/request-membership"
            render={(props: RouteComponentProps) => (
              <RequestMembership {...props} />
            )}
          />
          <Route
            path="/create-password/:otp"
            render={(props: RouteComponentProps) => (
              <UpdatePasswordWrapper {...props} />
            )}
          />
        </Switch>
      </React.Suspense>
    </Router>
  );
};

export default App;
